import { ILoginData } from "../../repository/ILoginData";

export const login = (payload: ILoginData) => ({
  type: "@saga/LOGIN",
  payload,
});
